
<template>
  <!--物业账号管理-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="user_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="[]"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'propertyAccount',
  data () {
    return {
      searchList: [
        { label: '', props: ['keywords'], placeholder: '公司、账号名、手机号', inputType: 'input' },
        { label: '', props: ['role_id'], placeholder: '角色', options: [], inputType: 'select' },
        { label: '', props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: '',
        role_id: '',
        create_date: ''
      },
      columns: [
        { title: '账号名', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '手机', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '姓名', dataIndex: 'true_name', align: 'left', width: '' },
        { title: '角色', dataIndex: 'role_name', align: 'left', width: '' },
        { title: '公司名', dataIndex: 'property_name', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      rowOptList: [
        { text: '重置密码', handle: (row) => this.resetPwd(row.user_id), key: 'resetPwd' },
        { text: '修改', handle: (row) => this.$children[0].toEdit(row), key: 'edit' }
        // { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      dataSource: [],
      listApi: {
        url: '/property/user',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'editPropertyAccount',
        title: '编辑物业账号'
      },
      deleteParam: {
        url: '/property/user',
        param: { pk_key: 'user_id', pk_val: '' },

        title: '物业账号',
        key: 'nick_name'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.propertyManageSelect([{index: 1, key: 'property_roles'}]);
    },
    /* 密码重置 */
    resetPwd (id) {
      this.$post({
        url: '/property/user/reset_password',
        params: { user_id: id }
      }).then((res) => {
        this.$message.success('密码重置成功！');
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/property/account/propertyAccount.vue